import { messaging, getToken, onMessage } from '../firebase/firebase';

const VAPID_KEY = 'BLAIWQ0um6hEmKP6CN9d85Cs2tm8Esgma7-Vk18VXoea5ZeoDENK9sSrD7x7C132jmw5SBYWxG-MgQD0Z9NSHos';

export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            // const token =
            await getToken(messaging, { vapidKey: VAPID_KEY });
            // console.log('FCM Token:', token);
            // send token to backend if needed
        } else {
            console.error('Permission not granted');
        }
    } catch (err) {
        console.error('Error getting permission/token:', err);
    }
};

export const listenForMessages = () => {
    onMessage(messaging, (payload) => {
        console.log('Message received:', payload);
        // Show custom notification UI here
    });
};
